export const GET_SCRAP_CERTIFY_KEY = 'GET_SCRAP_CERTIFY_KEY';










// 아래 제거될 항목
// 인증
export const LOGIN_SNS = 'LOGIN_SNS';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const REDIRECT = 'REDIRECT';
export const MEMBER_JOIN = 'MEMBER_JOIN';

export const TAB_MY_BOOK = 'TAB_MY_BOOK';
export const TAB_BOOK_MANAGE = 'TAB_BOOK_MANAGE';
export const TAB_BUDGET_MANAGE = 'TAB_BUDGET_MANAGE';
export const TAB_MORE = 'TAB_MORE';
export const TAB_SUB_CHANGE_BOOK = 'TAB_SUB_CHANGE_BOOK';
export const ENTER_BOOK = 'ENTER_BOOK'; // 장부이동
export const GET_CHANGE_BOOK_LIST = 'GET_CHANGE_BOOK_LIST'
export const CANCEL_CONNECTION_SEND = 'CANCEL_CONNECTION_SEND'
export const SUBMIT_CONNECTION_SEND = 'SUBMIT_CONNECTION_SEND'
export const UPDATE_CONNECTION_RECEIVE = 'UPDATE_CONNECTION_RECEIVE'
export const GET_CONNECTION_ABLE = 'GET_CONNECTION_ABLE'
export const POPUP_CONNECTION_SEND = 'POPUP_CONNECTION_SEND'
export const POPUP_CONNECTION_CLOSE = 'POPUP_CONNECTION_CLOSE'
export const POST_MYPAGE_CONNECTION_SEND = 'POST_MYPAGE_CONNECTION_SEND'
export const UNLOAD_CHANGE_BOOK = 'UNLOAD_CHANGE_BOOK'
export const GET_CHANGE_BOOK_REQUEST = 'GET_CHANGE_BOOK_REQUEST'
export const GET_MY_BOOK_CARD_BANK = 'GET_MY_BOOK_CARD_BANK'
export const ADD_BOOK = 'ADD_BOOK' //장부생성

// 가계부 관리
export const GET_BOOK_MANAGE_TRANS_LIST = 'GET_BOOK_MANAGE_TRANS_LIST'
export const GET_BOOK_MANAGE_TRANS_CATE = 'GET_BOOK_MANAGE_TRANS_CATE'
export const GET_BOOK_MANAGE_TRANS_BILL = 'GET_BOOK_MANAGE_TRANS_BILL' // 명세서
export const TRANS_UPDATE_FIELD = 'TRANS_UPDATE_FIELD'
export const GET_BOOK_MANAGE_TRANS_METHOD = 'GET_BOOK_MANAGE_TRANS_METHOD'
export const GET_TRANS_DETAIL = 'GET_TRANS_DETAIL'
export const UPDATE_TRANS_DETAIL_FIELD = 'UPDATE_TRANS_DETAIL_FIELD'
export const UNLOAD_TRANS_DETAIL = 'UNLOAD_TRANS_DETAIL'
export const DELETE_TRANS_TAG = 'DELETE_TRANS_TAG'
export const UPDATE_TRANS = 'UPDATE_TRANS'
export const INSERT_TRANS = 'INSERT_TRANS'
export const DELETE_TRANS = 'DELETE_TRANS'
export const UNLOAD_BOOK_MANAGE = 'UNLOAD_BOOK_MANAGE'
export const TRANS_UPDATE_RECEIPT = 'TRANS_UPDATE_RECEIPT'

export const TAB_MONTH_KIND = 'TAB_MONTH_KIND'
export const TAB_IS_OPEN = 'TAB_IS_OPEN'

//재무보고서
export const TAB_FINANCIAL_REPORT = 'TAB_FINANCIAL_REPORT';
export const TAB_SUB_FINANCIAL_REPORT = 'TAB_SUB_FINANCIAL_REPORT'
export const GET_FINANCIAL_REPORT_LIST = 'GET_FINANCIAL_REPORT_LIST'
export const GET_SUMMARY_TODAY_BALANCE = 'GET_SUMMARY_TODAY_BALANCE'
export const GET_FINANCIAL_REPORT_LIST_CHART = 'GET_FINANCIAL_REPORT_LIST_CHART'

// MY 가계부
export const GET_MY_BOOK_TODAY = 'GET_MY_BOOK_TODAY'
export const GET_MY_BOOK_MONTH = 'GET_MY_BOOK_MONTH'
export const UNLOAD_MY_BOOK = 'UNLOAD_MY_BOOK'

// 설정 - 내정보
export const UPDATE_MEMBER = 'UPDATE_MEMBER'
export const UPDATE_MEMBER_OK = 'UPDATE_MEMBER_OK'
export const LOAD_MEMBER_INFO = 'LOAD_MEMBER_INFO'
export const UPDATE_STARTDAY = 'UPDATE_STARTDAY'
export const UPDATE_MEMBER_LEAVE = 'UPDATE_MEMBER_LEAVE'

// 자산
export const GET_JASAN_LIST = 'GET_JASAN_LIST'
export const GET_JASAN_SCRAP = 'GET_JASAN_SCRAP'
export const GET_JASAN_ALL = 'GET_JASAN_ALL'
export const GET_HIDDEN_ALL = 'GET_HIDDEN_ALL'
export const GET_DELETE_ALL = 'GET_DELETE_ALL'

export const GET_SCRAP_INFOS = 'GET_SCRAP_INFOS'
export const SELECTED_CERT = 'SELECTED_CERT'
export const SELECTED_JASAN = 'SELECTED_JASAN'
export const SELECTED_ACCOUNT = 'SELECTED_ACCOUNT'
export const REGIST_JASAN = 'REGIST_JASAN'
export const REGIST_JASAN_END = 'REGIST_JASAN_END'
export const JASAN_HIDE = 'JASAN_HIDE'
//    export const UPDATE_JASAN_HIDE_END = 'UPDATE_JASAN_HIDE_END'
export const DELETE_JASAN = 'DELETE_JASAN'
//    export const DELETE_JASAN_END = 'DELETE_JASAN_END'
export const CHANGE_CERT = 'CHANGE_CERT'
export const CHANGE_CERT_END = 'CHANGE_CERT_END'
export const UPDATE_CERTIFY = 'UPDATE_CERTIFY'
export const UPDATE_CERTIFY_END = 'UPDATE_CERTIFY_END'
export const JASAN_ACTION_END = 'JASAN_ACTION_END'
export const TAB_ASSET_MORE = 'TAB_ASSET_MORE'

export const GET_SCRAP_JASAN_INFOS = 'GET_SCRAP_JASAN_INFOS'
export const UNLOAD_SCRAP = 'UNLOAD_SCRAP'


export const LOAD_SCRAP_LAST_DATE = 'LOAD_SCRAP_LAST_DATE'
export const UPDATE_CERTIFY_ON_OFF = 'UPDATE_CERTIFY_ON_OFF'
export const JASAN_SET_UNMOUNT = 'JASAN_SET_UNMOUNT'


// WEBPACK FOOTER //
// ./src/constants/actionTypes.js